import { camelize } from "../util/string"
import { events, isReadOnly } from "./sortableEvents"
import { isHtmlAttribute } from "../util/tags"

function project(entries) {
  return entries.reduce((res, [key, value]) => {
    res[key] = value
    return res
  }, {})
}

function getComponentAttributes({ $attrs, componentData = {} }) {
  const attributes = project(Object.entries($attrs).filter(([key]) => isHtmlAttribute(key)))
  return {
    ...attributes,
    ...componentData,
  }
}

function createSortableOption({ $attrs, callBackBuilder }) {
  const options = project(getValidSortableEntries($attrs))
  Object.entries(callBackBuilder).forEach(([eventType, eventBuilder]) => {
    events[eventType].forEach((event) => {
      options[`on${event}`] = eventBuilder(event)
    })
  })
  // JOERG: If we have the below original line, then for Single Pages it won't drag&drop be selectable
  // const draggable = `[data-draggable]${options.draggable || ""}`;
  const draggable = `${options.draggable || ""}`
  return {
    ...options,
    draggable,
  }
}

function getValidSortableEntries(value) {
  return Object.entries(value)
    .filter(([key]) => !isHtmlAttribute(key))
    .map(([key, value]) => [camelize(key), value])
    .filter(([key]) => !isReadOnly(key))
}

export { getComponentAttributes, createSortableOption, getValidSortableEntries }
